<template>
  <div 
    :style="isOneTime ? 'position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 100%; max-width: 400px;' : ''">
    <v-container v-if="questionInfo && !isOneTime">
      <div v-if="Survey && webform_theme.logo">
        <v-card
          v-if="Survey && webform_theme.logo_type === 'normal'"
          flat
          tile
          class="d-flex justify-start rounded-t-sm"
          width="100%"
          :color="webform_theme.header_bg"
        >
          <v-card
            flat
            color="transparent"
            :class="`d-flex pa-0 ma-0 align-${webform_theme.logo_image.align} ${
              webform_theme.logo_image.margin ? 'pl-1' : ''
            }`"
          >
            <v-avatar
              v-show="webform_theme.logo"
              color="transparent"
              :class="`rounded-${webform_theme.logo_image.rounded} ${
                webform_theme.logo_image.margin ? 'my-1' : ''
              }`"
              :size="webform_theme.logo_image.size"
            >
              <img
                v-if="webform_theme.logo"
                :src="webform_theme.logo_image.url"
              />
            </v-avatar>
          </v-card>
          <v-card flat color="transparent">
            <v-card-title
              :style="{
                color: webform_theme.header_text,
                'word-break': 'break-word',
              }"
            >
              {{ Survey.surveyName }}</v-card-title
            >
            <v-card-subtitle
              v-if="Survey.surveyDetail ? Survey.surveyDetail.trim() : false"
              :style="{
                color: webform_theme.header_text,
                'word-break': 'break-word',
              }"
              >รายละเอียด: {{ Survey.surveyDetail }}
            </v-card-subtitle>
          </v-card>
        </v-card>
        <v-card-title
          v-if="Survey && webform_theme.logo_type === 'banner'"
          class="justify-center px-0"
        >
          <img
            :src="webform_theme.logo_image.url"
            :width="widthCard"
            height="auto"
          />
        </v-card-title>
      </div>
      <div v-if="Survey && !webform_theme.logo">
        <v-card
          flat
          tile
          class="d-flex justify-start rounded-t-sm"
          width="100%"
          :color="webform_theme.header_bg"
        >
          <v-card flat color="transparent">
            <v-card-title
              :style="{
                color: webform_theme.header_text,
                'word-break': 'break-word',
              }"
            >
              {{ Survey.surveyName }}</v-card-title
            >
            <v-card-subtitle
              v-if="Survey.surveyDetail ? Survey.surveyDetail.trim() : false"
              :style="{
                color: webform_theme.header_text,
                'word-break': 'break-word',
              }"
              >รายละเอียด: {{ Survey.surveyDetail }}
            </v-card-subtitle>
          </v-card>
        </v-card>
      </div>
      <v-card-title :style="`background-color: ${hexToRGB('#FBFBFBFF', 0.5)}`">
        คำถาม
      </v-card-title>
      <v-form ref="form">
        <v-card
          :color="webform_theme.q_bgcolor"
          class="d-flex align-end py-6 flex-column"
          flat
          tile
          :style="` min-height: 30px;
              height: auto !important; /* for IE as it does not support min-height */
              height: 30px;
              border: ${webform_theme.q_border_px}px solid ${webform_theme.q_border_color};
            `"
        >
          <v-card class="pa-0 ma-0" width="100%" flat color="transparent">
            <v-container style="color: red">
              <v-sheet ref="chatbox" color="transparent">
                <v-row
                  v-for="(message, index) in questionInfo.questions"
                  :key="index"
                >
                  <v-col cols="12" class="py-0">
                    <v-card
                      class="d-flex mb-2 align-center"
                      :class="[
                        message.type === 'image' || message.type === 'video'
                          ? 'justify-center'
                          : 'justify-start',
                      ]"
                      flat
                      tile
                      color="transparent"
                    >
                      <div
                        v-if="message.type === 'image'"
                        class="d-flex pa-0 ma-0 my-2 align-center"
                      >
                        <v-card
                          color="transparent"
                          class="d-flex justify-center"
                          flat
                          tile
                        >
                          <img :src="message.payload.url" width="200" />
                        </v-card>
                      </div>
                      <div
                        v-else-if="message.type === 'video'"
                        class="d-flex pa-0 ma-0 my-2 align-center"
                      >
                        <v-card
                          color="transparent"
                          class="d-flex justify-center"
                          flat
                          tile
                        >
                          <video
                            width="200"
                            controls
                            :src="message.payload.url"
                          >
                            Your browser does not support the video tag.
                          </video>
                        </v-card>
                      </div>
                      <div v-else class="d-flex pa-0 ma-0 align-center">
                        <v-card
                          class="rounded"
                          color="transparent"
                          flat
                          tile
                          :style="{
                            'white-space': 'pre-line',
                            'word-break': ' break-word',
                            'font-size': '18px',
                            color: webform_theme.q_text_color,
                          }"
                        >
                          {{ message.payload.text }}
                        </v-card>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-sheet>
            </v-container>
          </v-card>
        </v-card>
        <CheckboxGroup
          v-if="questionInfo.conditionType === 'multiselect'"
          :data="questionInfo"
          :min="questionInfo.conditionsAnswer.match[0].min"
          :max="questionInfo.conditionsAnswer.match[0].max"
          :checkbox_row="webform_theme.checkbox_row"
          :bgcolor="webform_theme.ans_bgcolor"
          :color="webform_theme.ans_color"
          :color_text="webform_theme.ans_text_color"
          :border_px="webform_theme.ans_border_px"
          :border_color="webform_theme.ans_border_color"
          @Answer="setAnswer"
          @SendByEnter="SendAnswer"
          ref="checkbok"
        />
        <ButtonGroup
          v-else-if="questionInfo.conditionType === 'fixtext'"
          :data="questionInfo"
          :radio_row="webform_theme.radio_row"
          :bgcolor="webform_theme.ans_bgcolor"
          :color="webform_theme.ans_color"
          :color_text="webform_theme.ans_text_color"
          :border_px="webform_theme.ans_border_px"
          :border_color="webform_theme.ans_border_color"
          @Answer="setAnswer"
          ref="button"
        />
        <LongAnswer
          v-else-if="questionInfo.conditionType === 'freetext'"
          :data="questionInfo.questions"
          :bgcolor="webform_theme.ans_bgcolor"
          :color="webform_theme.ans_color"
          :color_text="webform_theme.ans_text_color"
          :border_px="webform_theme.ans_border_px"
          :border_color="webform_theme.ans_border_color"
          @Answer="setAnswer"
          ref="longtext"
        />
        <NumberAnswer
          v-else-if="questionInfo.conditionType === 'number'"
          :data="questionInfo.questions"
          :bgcolor="webform_theme.ans_bgcolor"
          :color="webform_theme.ans_color"
          :color_text="webform_theme.ans_text_color"
          :border_px="webform_theme.ans_border_px"
          :border_color="webform_theme.ans_border_color"
          @Answer="setAnswer"
          @SendByEnter="SendAnswer"
          ref="numberans"
        />
        <v-card flat tile color="transparent">
          <v-card-actions>
            <v-btn
              v-show="AllowBack"
              @click="config ? false : RestartQuestion()"
              :color="webform_theme.restart_button.bg_color"
              :style="`color: ${webform_theme.restart_button.text_color}`"
              :text="webform_theme.restart_button.bt_texttype === 'text'"
              :outlined="
                webform_theme.restart_button.bt_texttype === 'outlined'
              "
              style="font-size: 16px"
            >
              {{ webform_theme.restart_button.text }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              @click="SendAnswer"
              :color="webform_theme.button.bg_color"
              :style="`color: ${webform_theme.button.text_color}`"
              dark
              :text="webform_theme.button.bt_texttype === 'text'"
              :outlined="webform_theme.button.bt_texttype === 'outlined'"
              style="font-size: 16px"
            >
              {{ webform_theme.button.text }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-container>
    <v-card 
      v-if="isOneTime"
      flat 
      class="rounded-lg py-10 px-10" 
      width="100%"
      style="margin-left: auto; margin-right: auto; max-width: fit-content;"
    >
      <div class="d-flex justify-center mt-3">
        <v-icon x-large color="#D69120">question_answer</v-icon>
      </div>
      <v-card-title class="d-flex justify-center pt-1">
        <span style="font-size: 20px;">บัญชี "{{usernameOneID ? usernameOneID : 'Unknown User'}}"</span>
      </v-card-title>
      <v-card-subtitle class="d-flex justify-center pt-1">
        <span style="font-size: 20px;">ได้ทำแบบสอบถามนี้ไปแล้ว</span>
      </v-card-subtitle>
    </v-card>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import jwtDecode from "jwt-decode";
import CheckboxGroup from "../../components/FormUI/CheckboxGroup.vue";
import ButtonGroup from "../../components/FormUI/ButtonGroup.vue";
import LongAnswer from "../../components/FormUI/LongAnswer.vue";
import NumberAnswer from "../../components/FormUI/NumberAnswer.vue";
export default {
  props: [
    "config",
    "webform_theme",
    "logo",
    "logo_image",
    "checkbox_row",
    "radio_row",
    "qselect",
    "surveyInfo",
    "mobile_mode",
  ],
  components: { CheckboxGroup, ButtonGroup, LongAnswer, NumberAnswer },
  data() {
    return {
      questionInfo: null,
      answer: "",
      answerformulti: "",
      formend: false,
      endmsg: [],
      qlist: [],
      anslist: [],
      once: false,
      isOneTime: false,
      usernameOneID: '',
    };
  },
  created() {
    if (
      this.$cookies.get(
        process.env.VUE_APP_COOKIE +
          "_" +
          this.$route.query.surveySession +
          "_questionStep"
      )
    ) {
      this.qlist = this.$cookies.get(
        process.env.VUE_APP_COOKIE +
          "_" +
          this.$route.query.surveySession +
          "_questionStep"
      ).qlist;
    }
    if (
      this.$cookies.get(
        process.env.VUE_APP_COOKIE +
          "_" +
          this.$route.query.surveySession +
          "_answerStep"
      )
    ) {
      this.anslist = this.$cookies.get(
        process.env.VUE_APP_COOKIE +
          "_" +
          this.$route.query.surveySession +
          "_answerStep"
      ).anslist;
    }
    if (this.$route.query) {
      if (this.$store.state.firstquestion) {
        this.questionInfo = this.$store.state.firstquestion;
      } else {
        this.getQuestion(this.$route.query.questionID);
      }
    }
    if (this.webform_theme) {
      if (!Object.keys(this.webform_theme).includes("banner_size")) {
        this.webform_theme.banner_size = 100;
      }
    }
  },
  watch: {
    webform_theme: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (oldValue && newValue) {
          if (!Object.keys(this.webform_theme).includes("logo_type")) {
            this.webform_theme.logo_type = "normal";
          }
          if (!Object.keys(this.webform_theme).includes("banner_size")) {
            this.webform_theme.banner_size = 100;
          }
        }
      },
    },
    qlist(newValue) {
      this.$cookies.set(
        process.env.VUE_APP_COOKIE +
          "_" +
          this.$route.query.surveySession +
          "_questionStep",
        {
          qlist: newValue,
        }
      );
    },
    anslist(newValue) {
      this.$cookies.set(
        process.env.VUE_APP_COOKIE +
          "_" +
          this.$route.query.surveySession +
          "_answerStep",
        {
          anslist: newValue,
        }
      );
    },
    qselect(newValue, oldValue) {
      if (newValue) {
        if (newValue !== oldValue) {
          this.getQuestion(newValue);
        }
      }
    },
  },
  computed: {
    AllowBack() {
      return this.qlist.length > 0 || this.config;
      // return false;
    },
    Survey() {
      if (
        this.$cookies.get(process.env.VUE_APP_COOKIE + "_surveyInfo") &&
        !this.config
      ) {
        return this.$cookies.get(process.env.VUE_APP_COOKIE + "_surveyInfo");
      } else {
        if (!this.config) {
          return this.$store.state.surveyInfoNoCookie;
        } else {
          return this.surveyInfo;
        }
      }
    },
    TabletSize() {
      const { mdAndDown } = this.$vuetify.breakpoint;
      return mdAndDown;
    },
    widthCard() {
      if (this.TabletSize || this.mobile_mode) {
        return "100%";
      } else {
        if (this.webform_theme.logo) {
          if (!this.webform_theme.banner_size) {
            return "100%";
          } else {
            return this.webform_theme.banner_size + "%";
          }
        } else {
          return "100%";
        }
      }
    },
  },
  methods: {
    RestartQuestion() {
      let data = {
        surveySession: this.$route.query.surveySession,
        surveyID: this.$route.query.surveyID,
        questionID: this.questionInfo.questionID,
        answer: this.answer,
        socialType: "webform",
        socialID: this.$route.query.surveyID,
        userID: this.$route.query.userID,
        username: this.$route.query.username,
      };
      this.$store
        .dispatch("backToStartForm", data)
        .then(() => {
          if (this.$route.query.shared_token) {
            let param = {
              surveyID: this.$route.query.surveyID,
            };
            if (this.$route.query.shared_token) {
              param.shared_token = this.$route.query.shared_token;
            }
            if (this.$route.query.socialType) {
              param.socialType = this.$route.query.socialType;
            }
            if (this.$route.query.token) {
              param.token = this.$route.query.token;
            }
            if (this.$route.query.socialID) {
              param.socialID = this.$route.query.socialID;
            }
            this.$router.push({
              name: "startform",
              query: param,
            });
          } else {
            this.$router.push({
              name: "startform",
              query: {
                surveyID: this.$route.query.surveyID,
              },
            });
          }
        })
        .catch((err) => {
          // console.log(err);
          // console.log(this.answer)
          if (
            err.data.message ===
            "surveySession is Duplicate can use survey in one time"
          ) {
            this.isOneTime = true
            this.usernameOneID = this.$route.query.username
          } else {
            let text = "เกิดข้อผิดพลาด กรุณาติดต่อเจ้าหน้าที่";
            this.isOneTime = false
            if (err.data.message === "surveyInfo not in Schedule Time") {
              text = "แบบสอบถามไม่สามารถทำได้ในช่วงเวลานี้";
            } else if (err.data.message === "surveyInfo status inactive") {
              text = "แบบสอบถามนี้ถูกปิดแล้ว";
            }
            Swal.fire({
              icon: "error",
              text: text,
              title: "",
              allowOutsideClick: false,
              confirmButtonText: "กลับสู่หน้าหลัก",
            }).then(() => {
              this.$store.commit("ToggleLoading");
              this.$router.push({
                path: "startform",
                query: {
                  surveyID: this.$route.query.surveyID,
                },
              });
            });
          }
          // let text = "เกิดข้อผิดพลาด กรุณาติดต่อเจ้าหน้าที่";
          // if (
          //   err.data.message ===
          //   "surveySession is Duplicate can use survey in one time"
          // ) {
          //   text = `บัญชี "${this.$route.query.username}" ได้ทำแบบสอบถามนี้ไปแล้ว 1`;
          // } else if (err.data.message === "surveyInfo not in Schedule Time") {
          //   text = "แบบสอบถามไม่สามารถทำได้ในช่วงเวลานี้";
          // } else if (err.data.message === "surveyInfo status inactive") {
          //   text = "แบบสอบถามนี้ถูกปิดแล้ว";
          // }
          // Swal.fire({
          //   icon: "error",
          //   text: text,
          //   title: "",
          //   allowOutsideClick: false,
          //   confirmButtonText: "กลับสู่หน้าหลัก",
          // }).then(() => {
          //   this.$store.commit("ToggleLoading");
          //   this.$router.push({
          //     path: "startform",
          //     query: {
          //       surveyID: this.$route.query.surveyID,
          //     },
          //   });
          // });
        });
    },
    BackQuestion() {
      if (!this.config) {
        let data = {
          surveySession: this.$route.query.surveySession,
          surveyID: this.$route.query.surveyID,
          userID: this.$route.query.userID,
        };
        this.$store
          .dispatch("backQuestion", data)
          .then((response) => {
            this.$refs.form.reset();
            this.$refs.form.resetValidation();
            this.answer = "";
            if (response.questionInfo.conditionType === "multiselect") {
              response.questionInfo.conditionsAnswer.match = [
                response.questionInfo.conditionsAnswer.match[0],
              ];
              this.questionInfo = response.questionInfo;
            } else {
              this.questionInfo = response.questionInfo;
            }
            let prev = this.qlist[this.qlist.length - 2];
            this.qlist.pop();
            this.getQuestionBack(prev);
            this.$router.push({
              path: "webform",
              query: {
                surveyID: this.$route.query.surveyID,
                surveySession: this.$route.query.surveySession,
                username: this.$route.query.username,
                userID: this.$route.query.userID,
                questionID: response.questionInfo.questionID,
              },
            });
          })
          .catch((err) => {
            // console.log(err);
            // console.log(this.answer)
            let text = "เกิดข้อผิดพลาด กรุณาติดต่อเจ้าหน้าที่";
            if (
              err.data.message ===
              "surveySession is Duplicate can use survey in one time"
            ) {
              text = `บัญชี "${this.$route.query.username}" ได้ทำแบบสอบถามนี้ไปแล้ว`;
            } else if (err.data.message === "surveyInfo not in Schedule Time") {
              text = "แบบสอบถามไม่สามารถทำได้ในช่วงเวลานี้";
            } else if (err.data.message === "surveyInfo status inactive") {
              text = "แบบสอบถามนี้ถูกปิดแล้ว";
            }
            Swal.fire({
              icon: "error",
              text: text,
              title: "",
              allowOutsideClick: false,
              confirmButtonText: "กลับสู่หน้าหลัก",
            }).then(() => {
              this.$store.commit("ToggleLoading");
              this.$router.push({
                path: "startform",
                query: {
                  surveyID: this.$route.query.surveyID,
                },
              });
            });
          });
      }
    },
    setAnswer(data) {
      this.answer = data;
    },
    SendAnswer() {
      if (!this.config) {
        if (this.ValidateAnswer() && this.$refs.form.validate()) {
          let data = {
            surveySession: this.$route.query.surveySession,
            surveyID: this.$route.query.surveyID,
            questionID: this.questionInfo.questionID,
            answer: this.answer,
            socialType: "webform",
            socialID: this.$route.query.surveyID,
            userID: this.$route.query.userID,
            username: this.$route.query.username,
          };
          this.$store
            .dispatch("StartForm", data)
            .then((response) => {
              let param = {
                surveyID: this.$route.query.surveyID,
                surveySession: this.$route.query.surveySession,
                username: this.$route.query.username,
                userID: this.$route.query.userID,
                questionID: response.questionInfo.questionID,
              };
              if (this.$route.query.shared_token) {
                param.shared_token = this.$route.query.shared_token;
              }
              if (this.$route.query.socialType) {
                param.socialType = this.$route.query.socialType;
              }
              if (this.$route.query.token) {
                param.token = this.$route.query.token;
              }
              if (this.$route.query.socialID) {
                param.socialID = this.$route.query.socialID;
              }
              if (response.stage === "connect" || response.stage === "start") {
                this.$refs.form.reset();
                this.$refs.form.resetValidation();
                if (this.questionInfo.conditionType === "multiselect") {
                  this.anslist.push(this.answerformulti);
                } else {
                  this.anslist.push(this.answer);
                }
                this.answer = "";
                this.answerformulti = "";
                if (response.questionInfo.conditionType === "multiselect") {
                  response.questionInfo.conditionsAnswer.match = [
                    response.questionInfo.conditionsAnswer.match[0],
                  ];
                  this.questionInfo = response.questionInfo;
                } else {
                  this.questionInfo = response.questionInfo;
                }
                this.qlist.push(response.questionInfo.questionID);

                this.$router.push({
                  path: "webform",
                  query: param,
                });
              } else {
                this.$router.push({
                  path: "/webform/end",
                  query: param,
                });
              }
            })
            .catch((err) => {
              // console.log(err);
              // console.log(this.answer)
              if (err.data.message === "conditionAnswer fail") {
                Swal.fire({
                  icon: "error",
                  text: "รูปแบบคำตอบที่คุณเลือกไม่ถูกต้อง กรุณาเลือกใหม่",
                  title: "",
                  allowOutsideClick: false,
                  confirmButtonText: "ตกลง",
                });
                this.$store.commit("ToggleLoading");
              } else {
                if (
                  err.data.message ===
                  "surveySession is Duplicate can use survey in one time"
                ) {
                  this.isOneTime = true
                  this.usernameOneID = this.$route.query.username
                } else {
                  let text = "เกิดข้อผิดพลาด กรุณาติดต่อเจ้าหน้าที่";
                  this.isOneTime = false
                  if (
                    err.data.message === "surveyInfo not in Schedule Time"
                  ) {
                    text = "แบบสอบถามไม่สามารถทำได้ในช่วงเวลานี้";
                  } else if (err.data.message === "surveyInfo status inactive") {
                    text = "แบบสอบถามนี้ถูกปิดแล้ว";
                  } else if (err.data.message === "nextQuestionInfo Not found") {
                    text = "ไม่มีข้อต่อไปจากการตอบคำถามข้อที่แล้ว";
                  }
                  Swal.fire({
                    icon: "error",
                    text: text,
                    title: "",
                    allowOutsideClick: false,
                    confirmButtonText: "กลับสู่หน้าหลัก",
                  }).then(() => {
                    this.$store.commit("ToggleLoading");
                    if (this.$route.query.shared_token) {
                      let jwtdata = jwtDecode(this.$route.query.shared_token);
                        if (this.$route.query.socialType) {
                          if (
                            this.$route.query.socialType === "ONECHAT" &&
                            this.$route.query.token &&
                            this.$route.query.socialID
                          ) {
                            this.$axios.post(
                              "https://chat-api.one.th/message/api/v2/disable_webview",
                              {
                                user_id: jwtdata.sub,
                                bot_id: this.$route.query.socialID,
                              },
                              {
                                headers: {
                                  Authorization:
                                    "Bearer " + this.$route.query.token,
                                },
                              }
                            );
                          } else if (
                            this.$route.query.socialType === "ONEPLATFORM" &&
                            this.$route.query.token
                          ) {
                            this.$axios.post(
                              "https://platform.one.th/chat/api/v1/chatbot-api/close-web-view",
                              {
                                one_id: jwtdata.sub,
                              },
                              {
                                headers: {
                                  Authorization:
                                    "Bearer " + this.$route.query.token,
                                },
                              }
                            );
                          } else if (this.$route.query.socialType === "FACEBOOK") {
                            Swal.fire({
                              html: "กดปุ่มขวาบนเพื่อปิดหน้าเว็บ",
                              icon: "success",
                              showCancelButton: false,
                              showConfirmButton: false,
                              allowOutsideClick: false,
                              allowEscapeKey: false,
                              allowEnterKey: false,
                              confirmButtonColor: "#0093cc",
                              confirmButtonText: "รับทราบ",
                            });
                          }
                        }
                      } else {
                        this.RestartQuestion();
                      }
                    });
                  }
                // let text = "เกิดข้อผิดพลาด กรุณาติดต่อเจ้าหน้าที่";
                // if (
                //   err.data.message ===
                //   "surveySession is Duplicate can use survey in one time"
                // ) {
                //   text = `บัญชี "${this.$route.query.username}" ได้ทำแบบสอบถามนี้ไปแล้ว 3`;
                // } else if (
                //   err.data.message === "surveyInfo not in Schedule Time"
                // ) {
                //   text = "แบบสอบถามไม่สามารถทำได้ในช่วงเวลานี้";
                // } else if (err.data.message === "surveyInfo status inactive") {
                //   text = "แบบสอบถามนี้ถูกปิดแล้ว";
                // } else if (err.data.message === "nextQuestionInfo Not found") {
                //   text = "ไม่มีข้อต่อไปจากการตอบคำถามข้อที่แล้ว";
                // }
                // Swal.fire({
                //   icon: "error",
                //   text: text,
                //   title: "",
                //   allowOutsideClick: false,
                //   confirmButtonText: "กลับสู่หน้าหลัก",
                // }).then(() => {
                //   this.$store.commit("ToggleLoading");
                //   if (this.$route.query.shared_token) {
                //     let jwtdata = jwtDecode(this.$route.query.shared_token);
                //     if (this.$route.query.socialType) {
                //       if (
                //         this.$route.query.socialType === "ONECHAT" &&
                //         this.$route.query.token &&
                //         this.$route.query.socialID
                //       ) {
                //         this.$axios.post(
                //           "https://chat-api.one.th/message/api/v2/disable_webview",
                //           {
                //             user_id: jwtdata.sub,
                //             bot_id: this.$route.query.socialID,
                //           },
                //           {
                //             headers: {
                //               Authorization:
                //                 "Bearer " + this.$route.query.token,
                //             },
                //           }
                //         );
                //       } else if (
                //         this.$route.query.socialType === "ONEPLATFORM" &&
                //         this.$route.query.token
                //       ) {
                //         this.$axios.post(
                //           "https://platform.one.th/chat/api/v1/chatbot-api/close-web-view",
                //           {
                //             one_id: jwtdata.sub,
                //           },
                //           {
                //             headers: {
                //               Authorization:
                //                 "Bearer " + this.$route.query.token,
                //             },
                //           }
                //         );
                //       } else if (this.$route.query.socialType === "FACEBOOK") {
                //         Swal.fire({
                //           html: "กดปุ่มขวาบนเพื่อปิดหน้าเว็บ",
                //           icon: "success",
                //           showCancelButton: false,
                //           showConfirmButton: false,
                //           allowOutsideClick: false,
                //           allowEscapeKey: false,
                //           allowEnterKey: false,
                //           confirmButtonColor: "#0093cc",
                //           confirmButtonText: "รับทราบ",
                //         });
                //       }
                //     }
                //   } else {
                //     this.RestartQuestion();
                //   }
                // });
              }
            });
        }
      }
    },
    ValidateAnswer() {
      let type = this.questionInfo.conditionType;
      switch (type) {
        case "multiselect":
          {
            let selected = [];
            let ans = "";
            let ansforback = "";
            let min = this.questionInfo.conditionsAnswer.match[0].min;
            let max = this.questionInfo.conditionsAnswer.match[0].max;
            this.questionInfo.conditionsAnswer.match.map((c) => {
              if (c.choice) {
                c.choice.map((s) => {
                  if (s.selected) {
                    selected.push(s);
                    if (s.description) {
                      ans === ""
                        ? (ans += `${s.text}:${s.detail}`)
                        : (ans += `,${s.text}:${s.detail}`);

                      ansforback === ""
                        ? (ansforback += `${s.text}{{&}}${s.detail}`)
                        : (ansforback += `,${s.text}{{&}}${s.detail}`);
                    } else {
                      ans === "" ? (ans += `${s.text}`) : (ans += `,${s.text}`);
                      ansforback === ""
                        ? (ansforback += `${s.text}`)
                        : (ansforback += `,${s.text}`);
                    }
                  }
                });
              }
            });
            this.answer = ans;
            this.answerformulti = ansforback;
            if (selected.length < 1) {
              Swal.fire({
                icon: "warning",
                text: "กรุณาเลือกอย่างน้อย 1 ตัวเลือก",
                title: "",
              });
            } else if (min === max && selected.length !== min) {
              Swal.fire({
                icon: "warning",
                text: `ต้องเลือกทั้งหมด ${min} ตัวเลือก`,
                title: "",
              });
            } else if (min === 1 && selected.length > max) {
              Swal.fire({
                icon: "warning",
                text: `เลือกได้ไม่เกิน ${max} ตัวเลือก`,
                title: "",
              });
            } else if (min > selected.length || max < selected.length) {
              Swal.fire({
                icon: "warning",
                text: `เลือกอย่างน้อย ${min} แต่ไม่เกิน ${max} ตัวเลือก`,
                title: "",
              });
            } else {
              return true;
            }
          }
          break;
        case "number":
          {
            if (isNaN(this.answer)) {
              Swal.fire({
                icon: "warning",
                text: "กรุณาตอบเป็นตัวเลข",
                title: "",
              });
            } else {
              return true;
            }
          }
          break;
        default: {
          if (!this.answer) {
            Swal.fire({
              icon: "warning",
              text: "คำตอบไม่สามารถเว้นว่างได้",
              title: "",
            });
          }

          return !!this.answer;
        }
      }
    },
    getQuestion(qid) {
      if (qid) {
        let api = {
          method: "get",
          url: `${process.env.VUE_APP_API}/manageSurvey/survey/${
            this.config
              ? this.$route.params.surveyID
              : this.$route.query.surveyID
          }/question/questioninfo/${qid}`,
          data: {},
        };
        this.$store.getters.SendAPIWithHeader(api).then((response) => {
          // console.log(this.anslist);
          if (response.data.conditionType === "multiselect") {
            response.data.conditionsAnswer.match = [
              response.data.conditionsAnswer.match[0],
            ];
            this.questionInfo = response.data;
          } else {
            this.questionInfo = response.data;
          }
        });
      }
    },
    getQuestionBack(qid) {
      if (qid) {
        let api = {
          method: "get",
          url: `${process.env.VUE_APP_API}/manageSurvey/survey/${
            this.config
              ? this.$route.params.surveyID
              : this.$route.query.surveyID
          }/question/questioninfo/${qid}`,
          data: {},
        };
        this.$store.getters.SendAPIWithHeader(api).then((response) => {
          // console.log(this.anslist);
          if (response.data.conditionType === "multiselect") {
            response.data.conditionsAnswer.match = [
              response.data.conditionsAnswer.match[0],
            ];

            if (this.anslist[this.anslist.length - 1]) {
              let prev = this.anslist[this.anslist.length - 1];
              this.anslist.pop();
              // console.log(prev);
              let choiceSelected = prev.split(",");
              for (const key1 in response.data.conditionsAnswer.match) {
                if (
                  Object.hasOwnProperty.call(
                    response.data.conditionsAnswer.match,
                    key1
                  )
                ) {
                  const button = response.data.conditionsAnswer.match[key1];
                  for (const key2 in button.choice) {
                    if (Object.hasOwnProperty.call(button.choice, key2)) {
                      const choice = button.choice[key2];
                      let text = choice.text;
                      if (choice.description) {
                        text = text + "{{&}}";
                      }
                      if (choiceSelected.includes(text)) {
                        choice.selected = true;
                      } else {
                        // console.log(choice);
                        // console.log(choiceSelected);
                        let filter = choiceSelected.filter((search) =>
                          new RegExp(text).test(search)
                        );
                        if (filter && filter.length === 1) {
                          let textwithdetail = filter[0].split("{{&}}")[0];
                          if (textwithdetail === choice.text) {
                            choice.selected = true;
                            choice.detail = filter[0].split("{{&}}")[1];
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            this.questionInfo = response.data;
          } else {
            this.questionInfo = response.data;
            if (this.anslist[this.anslist.length - 1]) {
              let prev = this.anslist[this.anslist.length - 1];
              this.anslist.pop();
              if (response.data.conditionType === "freetext") {
                this.$refs.longtext.setAns(prev);
              } else if (response.data.conditionType === "fixtext") {
                this.$refs.button.setAns(prev);
              } else if (response.data.conditionType === "number") {
                this.$refs.numberans.setAns(prev);
              }
            }
          }
        });
      }
    },
    hexToRGB(hex, alpha) {
      var r = parseInt(hex.slice(1, 3), 16),
        g = parseInt(hex.slice(3, 5), 16),
        b = parseInt(hex.slice(5, 7), 16);

      if (alpha) {
        return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
      } else {
        return "rgb(" + r + ", " + g + ", " + b + ")";
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
